import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import config from 'config'
import { toggleModal } from 'actions'
import ModalLinkShare from 'components/modal-link-share'
import removeTags from 'utils/removetags'
import { Subtitle } from 'components/styled/typography'
import { mapLanguageToComponentProps } from 'i18n'
import { MODAL_LINK_SHARE, MODAL_QR_SHARE } from 'modals'
import { ExternalLinkButton, Button } from 'components/styled/button'
import { I18nComponentType } from 'i18n-types'

interface ShareProps {
  dispatch: any
  url: string
  title?: string
  summary?: string
  services?: string[]
  i18n: I18nComponentType
  modal?: string
  showTitle?: boolean
  locationId?: string
}

const mapStateToProps = (state: any) => ({
  modal: state.global.modal,
})

const ShareWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.space.s8};
`

const StyledTitle = styled(Subtitle)`
  margin: 0;

  ${({ theme }) => theme.mediaQuery.tablet} {
    display: none;
  }
`
export function Share({
  i18n,
  url,
  title,
  summary,
  modal,
  dispatch,
  showTitle = true,
  services = ['web', 'linkedin', 'facebook', 'x-twitter'],
  locationId,
}: ShareProps) {
  const fullUrl = config.BASE_URL + url
  const encodedTitle = title && encodeURIComponent(title)
  const encodedSummary = summary && encodeURIComponent(removeTags(summary))

  return (
    <>
      <ShareWrapper>
        {showTitle && <StyledTitle>{i18n.share.share}</StyledTitle>}
        {services.includes('web') && (
          <>
            <Button
              variant="secondary"
              onClick={() => dispatch(toggleModal(MODAL_LINK_SHARE))}
              icon="link"
              event={{
                locationId: locationId || 'share',
                id: 'shareLinkButton',
                properties: {},
              }}
            />
            <Button
              variant="secondary"
              onClick={() => dispatch(toggleModal(MODAL_QR_SHARE))}
              icon="qr_code"
              event={{
                locationId: locationId || 'share',
                id: 'qrCodeButton',
                properties: {},
              }}
            />
          </>
        )}
        {services.includes('linkedin') && (
          <ExternalLinkButton
            href={`http://www.linkedin.com/shareArticle?mini=true&url=${fullUrl}&title=${encodedTitle}&summary=${encodedSummary}`}
            svgIcon="linkedin"
            target="_blank"
            variant="secondary"
            event={{
              locationId: locationId || 'share',
              id: 'shareLinkedinButton',
              properties: {},
            }}
          />
        )}
        {services.includes('facebook') && (
          <ExternalLinkButton
            href={`https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`}
            variant="secondary"
            target="_blank"
            svgIcon="facebook"
            event={{
              locationId: locationId || 'share',
              id: 'shareFacebookButton',
              properties: {},
            }}
          />
        )}
        {services.includes('x-twitter') && (
          <ExternalLinkButton
            href={`https://twitter.com/intent/tweet?url=${fullUrl}&text=${encodedTitle}`}
            variant="secondary"
            target="_blank"
            svgIcon="x-twitter"
            event={{
              locationId: locationId || 'share',
              id: 'shareTwitterButton',
              properties: {},
            }}
          />
        )}
        <ModalLinkShare
          id={MODAL_LINK_SHARE}
          isOpen={modal === MODAL_LINK_SHARE}
          onClose={() => {
            dispatch(toggleModal(MODAL_LINK_SHARE))
          }}
          url={fullUrl}
        />
        <ModalLinkShare
          id={MODAL_QR_SHARE}
          isOpen={modal === MODAL_QR_SHARE}
          onClose={() => {
            dispatch(toggleModal(MODAL_QR_SHARE))
          }}
          url={fullUrl}
          showQRCode
          title={title}
          event={{
            locationId: locationId || 'share',
            id: 'downloadQRCodeButton',
            properties: {},
          }}
        />
      </ShareWrapper>
    </>
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(Share)
